import { render, staticRenderFns } from "./PartnerImpersonator.vue?vue&type=template&id=114f94e4&scoped=true"
import script from "./PartnerImpersonator.vue?vue&type=script&lang=ts"
export * from "./PartnerImpersonator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114f94e4",
  null
  
)

export default component.exports